<template>
  <VDialog v-model="dialog" width="600px">
    <VCard style="position: relative">
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center">{{ $t("description") }}</VCardTitle>
      <VCardTitle class="text-center">{{
        rejectedItemDetails.description
      }}</VCardTitle>
      <VCardText>
        <div v-if="images.length" class="pdf-viewer__drop__reader">
          <div class="pdf-viewer__slide__box pdf-viewer__slide__box-1">
            <CoolLightBox
              :items="images"
              :index="coolBoxIndex"
              @close="coolBoxIndex = null"
            >
            </CoolLightBox>
            <div class="pdf-viewer__slide__box-1__hooper">
              <Hooper
                v-if="ready"
                :wheelControl="false"
                ref="carousel"
                pagination="no"
                :itemsToShow="1"
                style="height: 320px"
              >
                <Slide v-for="(img, i) in images" :key="i" :index="i">
                  <img
                    :style="{
                      width: 100 + '%',
                      objectFit: 'cover',
                      objectPosition: 'top center',
                    }"
                    :src="img"
                    @click="coolBoxIndex = i"
                    alt="..."
                  />
                  <div :style="{ backgroundImage: 'url(' + img + ')' }"></div>
                </Slide>
                <HooperNavigation slot="hooper-addons"></HooperNavigation>
              </Hooper>
            </div>
          </div>
        </div>
      </VCardText>
      <div class="d-flex justify-end">
        <Downloader
          v-if="ready"
          :address="rejectedItemDetails.files.attachmentLink"
          btn-class="blue--text"
          :file-name="rejectedItemDetails.files.attachmentFileName"
          icon
        />
      </div>
    </VCard>
  </VDialog>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import { prepareBase64 } from "@/utils/pureFunctions.js";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import Downloader from "@/components/ui/downloader";
export default {
  data() {
    return {
      dialog: false,
      rejectedItemDetails: {
        description: "",
        files: null,
      },
      ready: false,
      images: [],
      coolBoxIndex: null,
    };
  },
  components: { Hooper, Slide, HooperNavigation, CoolLightBox, Downloader },
  methods: {
    async open(initiatorId) {
      this.showLoading();
      try {
        this.dialog = true;
        const {
          data: { data },
        } = await this.$http.get(`user-agreement/detail/${initiatorId}`);
        this.rejectedItemDetails.description = data.reason;
        this.rejectedItemDetails.files = data.files[0];
        this.$nextTick(() => {
          setTimeout(() => {
            this.ready = true;
          }, 1000);
        });

        const {
          data: { data: getImg },
        } = await this.$http.get(
          `attachment/base64/${data.files[0].attachmentLink}`
        );
        this.images = prepareBase64(getImg.base64s);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    close() {
      this.dialog = false;
      this.ready = false;
    },
  },
};
</script>

<style>
.hooper .hooper-track {
  padding: 0 !important;
}
</style>
